import React from 'react';
import { SyncOutlined } from '@ant-design/icons';

/**
 * ChartSyncOverlay — Overlay for chart component during background data sync.
 * Shows sync status while keeping chart visible in background.
 * Usage: Wrap around content with position: relative parent
 *        <div style={{ position: 'relative' }}>
 *            <ChartSyncOverlay visible={isDataSyncing} />
 *            {content}
 *        </div>
 */
const ChartSyncOverlay = ({ visible }) => {
    if (!visible) return null;

    return (
        <div
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 105,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'rgba(255, 255, 255, 0.85)',
                backdropFilter: 'blur(2px)',
                animation: 'fadeIn 0.3s ease',
            }}
        >
            {/* Content directly on overlay - no white modal */}
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '16px',
                    textAlign: 'center',
                    padding: '32px 40px',
                    borderRadius: '8px',
                    maxWidth: '380px',
                }}
            >
                {/* Animated sync icon */}
                <div>
                    <SyncOutlined
                        spin
                        style={{
                            fontSize: '48px',
                            color: '#1677ff',
                        }}
                    />
                </div>

                {/* Text content on overlay */}
                <div>
                    <h3
                        style={{
                            fontWeight: 600,
                            fontSize: '16px',
                            color: '#1a1a1a',
                            margin: 0,
                            marginBottom: '8px',
                        }}
                    >
                        Syncing your Amazon data
                    </h3>
                    <p
                        style={{
                            fontSize: '13px',
                            color: '#555',
                            lineHeight: '1.6',
                            margin: 0,
                        }}
                    >
                        Numbers take 6–48 hours to fully load. We will email you when it's done.
                        <br />
                        While you wait, add your COGS and expenses - that's the one thing we can't pull from Amazon.
                    </p>
                </div>
            </div>

            {/* Keyframe animation */}
            <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to   { opacity: 1; }
                }
            `}</style>
        </div>
    );
};

export default ChartSyncOverlay;




